import { useQuery } from '@tanstack/react-query';
import { api } from '~/lib/api-client';
import { peopleSearchKeys } from '~/lib/query-keys';

/** One colleague the share field can suggest (FRONT-2667). */
export interface PersonSuggestion {
  userId: string;
  name: string | null;
  email: string;
}

const EMPTY: PersonSuggestion[] = [];

/**
 * FRONT-2667: colleagues in the caller's own workspace whose name or email
 * contains `query` — everyone who has signed in to Eddy there, minus the
 * caller. The server takes the workspace from the session, never from here.
 *
 * `query` is trimmed once and that one value feeds both the cache key and the
 * request, so an entry can never describe a different search (FRONT-1501).
 */
export function usePeopleSearch(query: string, enabled: boolean) {
  const q = query.trim();
  const result = useQuery<{ people: PersonSuggestion[] }>({
    queryKey: peopleSearchKeys.search(q),
    queryFn: () => api.get<{ people: PersonSuggestion[] }>(`/api/people/search?q=${encodeURIComponent(q)}`),
    enabled: enabled && q.length > 0,
    staleTime: 60_000,
  });
  return {
    people: result.data?.people ?? EMPTY,
    isFetching: result.isFetching,
    isError: result.isError,
  };
}
